import React from 'react';

import Badge from '../Badge';

import cx from '../../utils/classnames';

import styles from './iconWithBadge.module.scss';

import type { ReactNode } from 'react';

type Props = {
  className?: string;
  badgeClassName?: string;

  /** icon to show */
  icon: ReactNode;

  /** number to show on badge */
  number?: number;
};

export default function IconWithBadge(props: Props) {
  const { className, icon, number = 0, badgeClassName, ...rest } = props;

  return (
    <div className={cx(className, styles.wrapper)} {...rest}>
      {icon}
      {number > 0 && <Badge number={number} className={cx(styles.badgeWrapper, badgeClassName)} />}
    </div>
  );
}
